import { createFileRoute, redirect } from '@tanstack/react-router';

import { scratchpadDetailSearchSchema } from '@apps/web/features/admin_agent_scratchpad/model/search_params';

export const Route = createFileRoute('/_app/admin/agent/scratchpad/$note-id')({
    beforeLoad: ({ location, params }) => {
        throw redirect({
            to: '/admin/agent/notes/$note-id',
            params,
            search: scratchpadDetailSearchSchema.parse(location.search),
            replace: true,
        });
    },
});
